module.exports = __webpack_public_path__ + "static/slide-dog-2-2b9d13ca30ae6b432cf98331bdd4c97d.png";